import React from 'react';
import { Container, Typography } from '@mui/material';

const WeatherSpotting = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Weather Spotting
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Jordan Webb serves as the District 5 Assistant Skywarn Coordinator, helping monitor and report weather
        conditions to ensure community safety during severe weather events.
      </Typography>
    </Container>
  );
};

export default WeatherSpotting;
